//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import GenericModal from '../../../../shared-components/generico/GenericModal';

import ImportacaoLateral from './ImportacaoLateral';
import ImportacaoTabela from './ImportacaoTabela';
import ImportacaoDialogErros from './ImportacaoDialogErros';
import ImportacaoFinalizadaDialog from './ImportacaoFinalizadaDialog';

export default {
  name: 'Importacao',
  data() {
    return {
      idErro: -1,
      importacaoResources: this.$api.importacoes(this.$resource),
      tabSelecionada: null,
      cabecalhoImportacoes: [
        { text: 'Tipo', value: 'desImportacao', sortable: false },
        { text: 'Nome', value: 'nomArquivoOrigem', sortable: false },
        { text: 'Data', value: 'dtaCriacao', sortable: false },
        { text: '', value: 'desResultado', sortable: false },
      ],
      cabecalhoImportacoesFinalizados: [
        { text: 'Tipo', value: 'desImportacao', sortable: false },
        { text: 'Nome', value: 'nomArquivoOrigem', sortable: false },
        { text: 'Data', value: 'dtaCriacao', sortable: false },
        { text: '', value: 'desResultado', sortable: false },
      ],
      cabecalhoImportacoesAndamento: [
        { text: 'Tipo', value: 'desImportacao', sortable: false },
        { text: 'Nome', value: 'nomArquivoOrigem', sortable: false },
        { text: 'Status', value: 'indStatus', sortable: false },
      ],
      tableHeaderDetalheErros: [
        { text: 'Linha', value: 'linha', sortable: false },
        { text: 'Descrição', value: 'descricao', sortable: false },
      ],
      tableHeaderDetalheFinalizados: [
        { text: 'Ação', value: 'label', sortable: false },
        { text: 'Registros', value: 'value', sortable: false },
      ],
      importacaoDetalheErros: [],
      importacaoDetalheFinalizados: [],
    };
  },
  computed: {
    ...mapGetters('importacao', {
      importacoesAndamento: 'getImportacoesAndamento',
      importacoesFinalizadas: 'getImportacoesFinalizados',
      importacoesErros: 'getImportacoesErros',
      tiposImportacao: 'getTiposImportacao',
    }),
    ...mapGetters('roles', [
      'getAllRoles',
    ]),
    canImport() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter(el => el.endsWith('_IMPORTAR') || el.endsWith('_CRUD')).length;
    },
    getTiposImportacaoFiltrados() {
      return this.tiposImportacao;
    },
  },
  components: {
    ImportacaoTabela,
    ImportacaoLateral,
    GenericModal,
    ImportacaoDialogErros,
    ImportacaoFinalizadaDialog,
  },
  methods: {
    ...mapActions('importacao', [
      'popularImportacoesAndamento',
      'popularImportacoesFinalizados',
      'popularImportacoesErros',
    ]),
    accessForbidden() {
      if (!this.canImport) {
        this.$router.push({ name: 'inicio' });
        this.$toast.create('Acesso negado', 'snack', 3E3);
      }
    },
    uploadRealizado() {
      setTimeout(() => {
        this.popularImportacoes('tab-importacoes-andamento');
      }, 3000);
    },
    openDialog(ref) {
      this.$refs[ref].open();
    },
    closeDialog(ref) {
      this.$refs[ref].close();
    },
    getImportacoesDetalhesErros(row) {
      this.importacaoDetalheErros = this.separateErros(row.desResultado);
      this.openDialog('modalErros');
    },
    getImportacoesDetalhesFinalizados(row) {
      this.importacaoDetalheFinalizados = this.separateDetalhes(row.desResultado);
      this.importacaoDetalheErros = this.separateErros(row.desResultado);
      this.openDialog('modalFinalizada');
    },
    separateErros(item) {
      const resultado = JSON.parse(item.value);
      let erros = [];
      if (resultado.erros) {
        erros = resultado.erros.map((e) => {
          const erroMap = e.split(' ');
          const linha = parseInt(erroMap[0], 10);
          const param = erroMap[2] ? erroMap[2].replace(/_/g, ' ').replace(/\|/g, ', ') : '';

          const descricao = this.$t(`errors.importacao.${erroMap[1]}`, { param });
          return { linha, descricao };
        });

        erros.sort(
          (e1, e2) => {
            if (e1.linha > e2.linha) {
              return 1;
            }
            if (e2.linha > e1.linha) {
              return -1;
            }
            return 0;
          },
        );
      }
      return erros;
    },
    separateDetalhes(item) {
      const resultado = JSON.parse(item.value);
      return [{
        label: this.$t('label.registros_inseridos'),
        value: resultado.registros_inseridos ? resultado.registros_inseridos[0] : '0',
      },
      {
        label: this.$t('label.registros_atualizados'),
        value: resultado.registros_atualizados ? resultado.registros_atualizados[0] : '0',
      }];
    },
    popularImportacoes(param) {
      this.tabSelecionada = param;

      switch (this.tabSelecionada) {
        case 'tab-importacoes-finalizadas':
          this.popularImportacoesFinalizados(this.importacaoResources.listarFinalizado)
            .catch(() => {
              this.$toast.create(this.$t('message.erro_buscar_importacoes'), 'snack', 1000);
            });
          break;
        case 'tab-importacoes-erros':
          this.popularImportacoesErros(this.importacaoResources.listarErro)
            .catch(() => {
              this.$toast.create(this.$t('message.erro_buscar_importacoes'), 'snack', 1000);
            });
          break;
        default:
          this.popularImportacoesAndamento(this.importacaoResources.listarAndamento)
            .catch(() => {
              this.$toast.create(this.$t('message.erro_buscar_importacoes'), 'snack', 1000);
            });
          break;
      }
    },
  },
  mounted() {
    if (!this.canImport) {
      window.setTimeout(() => this.accessForbidden(), 1E3);
    }
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/importacao/Importacao.vue?vue&type=script&lang=js&